import User from '../../../../types/User';

// State
export interface EmployeesState {
    data: User[];
    error: string;
    loading: boolean;
    Page: number;
}

// Types ("type" field of an action)
export enum TypesEnum {
    employeesRequested = 'smoelenboek/employees/EMPLOYEES_REQUESTED',
    moreEmployeesRequested = 'smoelenboek/employees/MORE_EMPLOYEES_REQUESTED_REQUESTED',
    employeesRequestFailed = 'smoelenboek/employees/EMPLOYEES_REQUESTED_REQUEST_FAILED',
    employeesReceived = 'smoelenboek/employees/EMPLOYEES_REQUESTED_RECEIVED',
}

// Actions
export interface EmployeesRequestedAction {
    type: typeof TypesEnum.employeesRequested;
}

export interface MoreEmployeesRequestedAction {
    type: typeof TypesEnum.moreEmployeesRequested;
}
export interface EmployeesReceived {
    type: typeof TypesEnum.employeesReceived;
    payload: User[];
}

export interface EmployeesRequestFailedAction {
    type: typeof TypesEnum.employeesRequestFailed;
    payload: string;
}

export type EmployeeDashboardActionTypes =
    | EmployeesRequestedAction
    | MoreEmployeesRequestedAction
    | EmployeesRequestFailedAction
    | EmployeesReceived;
